import CaptureTrn from "@/modules/trn/pages/CaptureTrn.vue";
export default [
  {
    path: "/document/trn",
    name: "captureTrn",
    component: CaptureTrn,
  },
];
